/**
 * HTTP 请求工具模块
 * 基于 axios 封装统一的请求方法，包含请求/响应拦截器
 */
import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

/** 开启 cookie 缓存携带，确保后端能获取 cookie 数据 */
axios.defaults.withCredentials = true

/** 创建 axios 实例，设置通用超时时间为 60 秒 */
var instance = axios.create({ timeout: 60000 })

/**
 * 请求拦截器
 * 在所有请求发出前统一处理：根据 URL 自动附加对应的 JWT Token
 * - URL 包含 'admin' → 使用 adminToken
 * - URL 包含 'user' → 使用 token
 */
instance.interceptors.request.use(
  config => {
    let reg = config.url;
    if (reg.includes('admin')) {
      if (localStorage.getItem('adminToken')) {
        config.headers.Authorization = 'JWT ' + localStorage.getItem('adminToken')
      }
    } else {
      if (reg.includes('user')) {
        if (localStorage.getItem('token')) {
          config.headers.Authorization = 'JWT ' + localStorage.getItem('token')
        }
      }
    }
    return config;
  },
  error => {
    return Promise.error(error);
  }
)

/**
 * 响应拦截器
 * 统一处理 HTTP 响应状态：
 * - 200/201/204 → 正常返回
 * - 401 → 清除 Token 并跳转到对应登录页
 * - 其他 → 弹出警告提示
 */
instance.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response)
    } else if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status === 201) {
      return Promise.resolve(response)
    } else {
      Message.warning('接口调用异常')
      return Promise.reject(response);
    }
  },
  async error => {
    let reg = error.response.config.url;
    if (error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('adminToken')
      if (reg.includes('admin')) {
        router.push({ name: 'adminLogin' })
      } else if (reg.includes('user')) {
        router.push({ name: 'manageLogin' })
      }
    }
    return Promise.reject(error);
  }
)

/**
 * GET 请求
 * @param {string} url - 请求地址
 * @param {object} params - 查询参数
 * @returns {Promise} 响应数据
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    instance({
      url: url,
      method: 'get',
      params: params,
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * DELETE 请求
 * @param {string} url - 请求地址
 * @returns {Promise} 响应数据
 */
export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    instance({
      url: url,
      method: 'delete',
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}

/**
 * POST 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求体数据
 * @param {object} headers - 自定义请求头，默认 application/json
 * @returns {Promise} 响应数据
 */
export function post(url, params, headers) {
  if (headers == null) {
    headers = { 'Content-Type': 'application/json;charset=utf-8' }
  }
  return new Promise((resolve, reject) => {
    instance({
      url: url,
      method: 'post',
      data: params,
      headers: headers
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * PUT 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求体数据
 * @param {object} headers - 自定义请求头
 * @returns {Promise} 响应数据
 */
export function put(url, params, headers) {
  if (headers == null) {
    headers = { 'Content-Type': 'application/json;charset=utf-8' }
  }
  return new Promise((resolve, reject) => {
    instance({
      url: url,
      method: 'put',
      data: params,
      headers: headers
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * PATCH 请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求体数据
 * @param {object} headers - 自定义请求头
 * @returns {Promise} 响应数据
 */
export function patch(url, params, headers) {
  if (headers == null) {
    headers = { 'Content-Type': 'application/json;charset=utf-8' }
  }
  return new Promise((resolve, reject) => {
    instance({
      url: url,
      method: 'patch',
      data: params,
      headers: headers
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  instance
}



// WEBPACK FOOTER //
// ./src/utils/utils.js